import { StandardEvents } from '@shopify/events';

class CartNotice04 extends HTMLElement {
  mobile = window.matchMedia('(max-width: 749px)');
  timer;
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.cartAdded);
    this.querySelector('[data-cart04-notice-checkout]')?.addEventListener('click', this.checkout);
    this.mobile.addEventListener('change', this.hide);
    window.addEventListener('scroll', this.position, { passive: true });
    window.addEventListener('resize', this.position);
  }
  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.cartAdded);
    this.querySelector('[data-cart04-notice-checkout]')?.removeEventListener('click', this.checkout);
    this.mobile.removeEventListener('change', this.hide);
    window.removeEventListener('scroll', this.position);
    window.removeEventListener('resize', this.position);
    clearTimeout(this.timer);
  }
  hide = () => { this.hidden = true; clearTimeout(this.timer); };
  position = () => {
    if (this.hidden) return;
    const bottom = document.querySelector('#header-component')?.getBoundingClientRect().bottom || 0;
    this.style.setProperty('--cart04-notice-top', `${Math.max(0, bottom)}px`);
  };
  cartAdded = (event) => {
    if (event.action !== 'add' || !this.mobile.matches) return;
    const ids = new Set((event.lines || []).map((line) => String(line.merchandiseId).split('/').pop()));
    event.promise?.then(({ detail }) => {
      if (detail?.didError || !this.isConnected || !this.mobile.matches) return;
      const added = (detail?.items || []).find((item) => ids.has(String(item.variant_id || item.id)));
      if (!added) return;
      const size = added.options_with_values?.find((option) => /^(size|taglia|talla)$/i.test(option.name))?.value;
      this.querySelector('[data-cart04-notice-size]').textContent = size ? `Size ${size}` : added.variant_title && added.variant_title !== 'Default Title' ? added.variant_title : added.product_title || added.title;
      clearTimeout(this.timer);
      this.hidden = false;
      this.position();
      this.timer = setTimeout(this.hide, 5000);
    }).catch(() => {});
  };
  checkout = (event) => {
    const button = document.querySelector('#cart-drawer button[name="checkout"]') || document.querySelector('button[name="checkout"][form="cart-form"]');
    if (button && !button.disabled) {
      event.preventDefault();
      button.click();
    }
  };
}
if (!customElements.get('cart-notice-04')) customElements.define('cart-notice-04', CartNotice04);
